<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_17">Did We Miss You?</a></h2><a id="page_17">
<p class="noindent"><span class="big">A</span>lthough we’re fairly certain we found every last alternative career training program in the United States (and a few beyond it), there’s a remote possibility that we missed one or two. Or even three. If you know of a program or school that isn’t listed in this book but should be, please let us know. Thanks.</p>
</a><p class="block"><a id="page_17">Lee and Joel Naftali<br/>P.O. Box 2066<br/>Santa Barbara, CA 93120<br/>JRNaftali@aol.com</a><a id="page_18"></a></p><a id="page_18">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?891e188c